<template>
  <div class="sticky top-0 z-50 bg-dark-gray container__div">
    <div>
      <div class="flex flex-wrap">
        <div class="section w-full pr-10 lg:w-3/5">
          <div>
            <!-- Intro -->
            <div class="flex mt-4 border-b-2">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 rounded px-5 title">
                  Introducción
                </h2>
              </div>
            </div>
            <p class="px-5 my-4 text-sm xl:text-base">
              Bienvenidos a la sección documentación de Nirex. Aqui tendrás los
              recursos necesarios para poder realizar ordenes de los servicios
              de Nirex se habilitaron
              <span class="font-neue">endpoints</span> para el registro de
              ordenes y la consulta del estado de la orden.
            </p>
            <p class="px-5 my-4 text-sm xl:text-base">
              Estos servicios se encuentran registrados en el dominio de Nirex.
            </p>

            <!-- Autentificación -->
            <div class="flex mt-4 border-b-2 mt-5">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 px-5 title">
                  Autentificación
                </h2>
              </div>
            </div>

            <p class="px-5 text-sm xl:text-base py-3">
              Primero, debes crear tu cuenta como Empresa en :
            </p>
            <a
              class="px-5"
              href="https://programados.nirex.pe/auth/register"
              target="_blank"
              >https://programados.nirex.pe/auth/register</a
            >
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="require('@/assets/img/Dashboard/first-step.png')"
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 text-sm xl:text-base py-3">
              Luego nuestro equipo comercial te contactará y activará tu cuenta
              corporativa confirmando tus datos de acceso (E-Mail y Password).
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              Luego debes ingresar a
              <a href="https://programados.nirex.pe/auth/login" target="_blank"
                >https://programados.nirex.pe/auth/login</a
              >
              con las credenciales de acceso.
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              Una vez dentro, debes dirigirte a la sección Mi Cuenta y en la
              parte inferior derecha estará disponible el API_KEY asociado a tu
              empresa.
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="require('@/assets/img/Dashboard/second-step.png')"
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 text-sm xl:text-base py-3">
              Con dicha API key podrás tener acceso a nuestras APIs.
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              Nuestra API esperaran que el API se incluido para cada petición al
              servidor, ejemplo:
            </p>
            <p class="font-neue px-6 text-sm xl:text-base py-2 bg-block-purple text-primary">
              API-key = YOUR_NIREX_API_KEY
            </p>

            <!-- Servicios -->
            <div class="flex mt-4 border-b-2 my-5">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue px-5 py-2 title">Servicios</h2>
              </div>
            </div>

            <p class="px-5 text-sm xl:text-base">
              Estos servicios se encuentran registrados en el dominio de Nirex.
            </p>
            <!-- Tabla de tarifas -->
            <h3 class="text-xl font-neue border-light-purple py-2 px-5 my-5">
              I. Tablas de servicios de cobertura y tarifas
            </h3>
            <h4 id="api-order" class="text-lg font-neue py-1 text-center my-3">
              NEXTDAY | HORARIOS DE PROGRAMACIÓN: DE 6 A.M A 11:59 P.M DE L-D
            </h4>
            <div class="flex justify-center">
              <img
                class="flujo border-light-purple"
                :src="require('@/assets/img/Dashboard/cobertura_nextday.png')"
                alt="Flujo de integración"
              />
            </div>
            <h4 id="api-order" class="text-lg font-neue py-1 text-center my-3">
              IN HOUSE | HORARIOS DE PROGRAMACIÓN: DE 9 A.M A 1:00 P.M DE L-V
            </h4>
            <div class="flex justify-center">
              <img
                class="flujo border-light-purple"
                :src="require('@/assets/img/Dashboard/cobertura_sameday.png')"
                alt="Flujo de integración"
              />
            </div>

            <!-- Validar cobertura -->
            <h3 class="text-xl font-neue border-light-purple py-2 px-5 my-5">
              II. Validar cobertura de la direcciones de una Orden
            </h3>
            <p class="px-5 text-sm xl:text-base">
              Este endpoint permite validar cobertura de las direcciones de una
              orden antes de ser creados.
            </p>
            <h4 id="api-order" class="text-lg font-neue py-1 px-5 my-3">
              HTTP Request
            </h4>
            <p class="px-5 text-lg">Nexday:</p>
            <p class="px-5 text-sm xl:text-base bg-block-purple text-primary py-2">
              <span class="font-neue">POST</span>
              https://api-staging.nirex.pe/api/orders/validate
            </p>
            <p class="px-5 text-lg mt-2">In House:</p>
            <p class="px-5 text-sm xl:text-base bg-block-purple text-primary py-2">
              <span class="font-neue">POST</span>
              https://api-staging.nirex.pe/api/sameday/orders/validate
            </p>
            <h4 class="sub__titles py-2 px-5 text-lg font-neue my-3">
              Estructura de envio
            </h4>
            <div class="max-h-50 mb-8 overflow-auto">
              <table class="w-full text-sm text-white">
                <thead>
                  <tr class="border-b border-grey-light">
                    <th class="p-2 truncate">Atributo</th>
                    <th class="p-2 truncate">Tipo</th>
                    <th class="p-2 truncate">Descripción</th>
                    <th class="p-2 truncate">Proveedor</th>
                    <th class="p-2 truncate">Obligatoria</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in validateJson" :key="i">
                    <td class="py-3 font-bold px-2 text-center truncate">
                      {{ item.atributo }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.type }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.description }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.prove }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.request }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4 class="text-lg font-neue py-2 px-5 my-3">
              Estructura de la respuesta de la API
            </h4>
            <div class="max-h-50 mb-8 overflow-auto">
              <table class="w-full text-sm text-white">
                <thead>
                  <tr class="border-b border-grey-light">
                    <th class="p-2 truncate">Atributo</th>
                    <th class="p-2 truncate">Tipo</th>
                    <th class="p-2 truncate">Descripción</th>
                    <th class="p-2 truncate">Proveedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="py-3 px-2 text-center truncate">response</td>
                    <td class="py-3 px-2 text-center truncate">Integer</td>
                    <td class="py-3 px-5 truncate">
                      <span
                        >Código de respuesta (2001: no se pudo efectuar, 200:
                        direccion correcto y dentro de la cobertura,500: error
                        con el servidor)</span
                      >
                      <ul class="px-7 py-3">
                        <li>
                          2001: Error a nivel funcional, ejemplo: "Punto fuera
                          de cobertura"
                        </li>
                        <li>200: Éxito</li>
                        <li>500: Error con el servidor</li>
                      </ul>
                    </td>
                    <td class="py-3 px-2 text-center truncate">Nirex</td>
                  </tr>
                  <tr>
                    <td class="py-3 px-2 text-center truncate">
                      Descripción Response
                    </td>
                    <td class="py-3 px-2 text-center truncate">String</td>
                    <td class="py-3 px-5 truncate">
                      <span>Descripción de la respuesta</span>
                      <ul>
                        <li>400: "FAILED"</li>
                        <li>200: "SUCCESS"</li>
                      </ul>
                    </td>
                    <td class="py-3 px-2 text-center truncate">Nirex</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Crear una orden -->
            <h3 class="text-xl font-neue border-light-purple py-2 px-5 my-5">
              III. Creación de una orden
            </h3>
            <p class="px-5 text-sm xl:text-base">
              Este endpoint permite registrar una orden. Dado que en el envio es
              un arreglo, se puede registrar varios puntos a donde se desea que
              llegue Nirex. por lo tanto, se forma una ruta.
            </p>
            <h4
              id="api-order"
              class="text-lg font-neue text-gray-300 px-5 my-3"
            >
              HTTP Request
            </h4>
            <p class="px-5 text-lg">Nexday:</p>
            <p
              class="px-5 text-sm xl:text-base text-white bg-block-purple text-primary py-2"
            >
              <span class="font-neue">POST</span>
              https://api-staging.nirex.pe/api/orders
            </p>
            <p class="px-5 text-lg mt-2">In House:</p>
            <p
              class="px-5 text-sm xl:text-base text-white bg-block-purple text-primary py-2"
            >
              <span class="font-neue">POST</span>
              https://api-staging.nirex.pe/api/sameday/order
            </p>
            <h4 class="py-2 px-5 text-lg font-neue my-3">
              Estructura de envio
            </h4>
            <div class="max-h-50 mb-5 overflow-auto">
              <table class="w-full text-sm text-white">
                <thead>
                  <tr class="border-b border-grey-light">
                    <th class="p-2 truncate">Atributo</th>
                    <th class="p-2 truncate">Tipo</th>
                    <th class="p-2 truncate">Descripción</th>
                    <th class="p-2 truncate">Proveedor</th>
                    <th class="p-2 truncate">Obligatoria</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in orderJson" :key="i">
                    <td class="py-3 px-2 font-bold text-center truncate">
                      {{ item.atributo }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.type }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.description }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.prove }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.request }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4 class="text-lg font-neue py-2 px-5 my-2">
              Estructura de la respuesta de la API
            </h4>
            <div class="max-h-50 my-5 overflow-auto">
              <table class="w-full text-sm text-white">
                <thead>
                  <tr class="border-b border-grey-light">
                    <th class="p-2 truncate">Atributo</th>
                    <th class="p-2 truncate">Tipo</th>
                    <th class="p-2 truncate">Descripción</th>
                    <th class="p-2 truncate">Proveedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="py-3 px-2 text-center truncate">response</td>
                    <td class="py-3 px-2 text-center truncate">Integer</td>
                    <td class="py-3 px-5 truncate">
                      <span
                        >Código de respuesta (400: no se pudo efectuar, 200: se
                        registró correctamente,500: error con el servidor)</span
                      >
                      <ul class="px-7 py-3">
                        <li>
                          400: Error a nivel funcional, ejemplo: "Key no
                          encontrado"
                        </li>
                        <li>200: Éxito</li>
                        <li>500: Error con el servidor</li>
                      </ul>
                    </td>
                    <td class="py-3 px-2 text-center truncate">Nirex</td>
                  </tr>
                  <tr>
                    <td class="py-3 px-2 text-center truncate">
                      Descripción Response
                    </td>
                    <td class="py-3 px-2 text-center truncate">String</td>
                    <td class="py-3 px-5 truncate">
                      <span>Descripción de la respuesta</span>
                      <ul>
                        <li>400: "FAILED"</li>
                        <li>200: "SUCCESS"</li>
                      </ul>
                    </td>
                    <td class="py-3 px-2 text-center truncate">Nirex</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Obtener ordernes -->
            <h3 class="text-xl font-neue border-light-purple py-2 px-5 my-5">
              IV. Obtener ordenes creadas
            </h3>
            <p class="px-5 text-sm xl:text-base">
              Este endpoint permite ver la ordenes registradas. se obtendra es
              un arreglo y estados de las ordenes.
            </p>
            <h3 class="text-lg font-neue px-5 my-5">HTTP Request</h3>
            <p class="px-5 text-sm xl:text-base bg-block-purple text-primary py-2">
              <span class="font-neue">GET</span>
              https://api-staging.nirex.pe/api/orders/{orderId}
            </p>
            <h4 class="text-lg py-2 px-5 my-3">Resultados</h4>
            <div class="max-h-50 mb-5 overflow-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-grey-light">
                    <th class="p-2 truncate">Atributo</th>
                    <th class="p-2 truncate">Tipo</th>
                    <th class="p-2 truncate">Valores</th>
                    <th class="p-2 truncate">Descripción</th>
                    <th class="p-2 truncate">Proveedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in getOrderJSON" :key="i">
                    <td class="py-3 font-bold px-2 text-center truncate">
                      {{ item.atributo }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.type }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.values }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.description }}
                    </td>
                    <td class="py-3 px-2 text-center truncate">
                      {{ item.prove }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Cancelar orden -->
            <h3 class="text-xl font-neue border-light-purple py-2 px-5 my-5">
              V. Cancelar órdenes
            </h3>
            <p class="px-5 text-sm xl:text-base">
              Este endpoint permite cancelar las órdenes que se han creado vía
              API.
            </p>
            <p class="px-5 mt-2 font-bold text-sm xl:text-base">
              IMPORTANTE: Si la orden ya se ha asignado, no podrá ser cancelada.
            </p>
            <h3 class="text-lg font-neue px-5 my-5">HTTP Request</h3>
            <p class="px-5 text-sm xl:text-base bg-block-purple text-primary py-2">
              <span class="font-neue">PUT</span>
              https://api-staging.nirex.pe/api/orders/cancel/{orderId}/false
            </p>
            <h4 class="text-lg font-neue py-2 px-5 my-3">Resultados</h4>
            <div class="max-h-50 mb-8 overflow-auto">
              <table class="w-full text-sm text-white">
                <thead>
                  <tr class="border-b border-grey-light">
                    <th class="p-2 truncate">Atributo</th>
                    <th class="p-2 truncate">Tipo</th>
                    <th class="p-2 truncate">Descripción</th>
                    <th class="p-2 truncate">Proveedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="py-3 px-2 text-center truncate">response</td>
                    <td class="py-3 px-2 text-center truncate">Integer</td>
                    <td class="py-3 px-5 truncate">
                      <span
                        >Código de respuesta (2001: no se pudo efectuar, 200:
                        direccion correcto y dentro de la cobertura,500: error
                        con el servidor)</span
                      >
                      <ul class="px-7 py-3">
                        <li>
                          2001: Error a nivel funcional, ejemplo: "Orden
                          cancelada previamente"
                        </li>
                        <li>200: Éxito</li>
                        <li>500: Error con el servidor</li>
                      </ul>
                    </td>
                    <td class="py-3 px-2 text-center truncate">Nirex</td>
                  </tr>
                  <tr>
                    <td class="py-3 px-2 text-center truncate">
                      Descripción Response
                    </td>
                    <td class="py-3 px-2 text-center truncate">String</td>
                    <td class="py-3 px-5 truncate">
                      <span>Descripción de la respuesta</span>
                      <ul>
                        <li>400: "FAILED"</li>
                        <li>200: "SUCCESS"</li>
                      </ul>
                    </td>
                    <td class="py-3 px-2 text-center truncate">Nirex</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="section w-full lg:w-2/5">
          <div>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 200 + 'px' }"
            >
              Usar el siguiente codigo para la Autentificación.
            </div>
            <pre class="bg-black">
              <code>
                # Se puede enviar el encabeza
                en cada petición
                headers: {
                  key: API_KEY
                }
              </code>
            </pre>
            <h2
              class="text-xl font-neue my-5 px-2"
              :style="{ paddingTop: 2500 + 'px' }"
            >
              Request Body
            </h2>
            <div class="border-2 w-full px-10 text-lg py-2">
              Estructura del Json para validar la cobertura.
            </div>
            <pre class="bg-black">
              <code>
                {
                  "point":{
                    "lat":-12.0633144,
                    "lng":-77.1029698
                  }
                }
              </code>
            </pre>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 10 + 'px' }"
            >
              Respuesta de la API si la dirección no es válida
            </div>
            <pre class="bg-black">
              <code>
              {
                "codeError": 2001,
                "msg": "Punto fuera de cobertura"
              }
              </code>
            </pre>
            <h2
              class="text-xl font-neue my-5 px-2"
              :style="{ paddingTop: 300 + 'px' }"
            >
              Request Body
            </h2>

            <div class="border-2 px-10 text-lg py-2">
              Estructura del Json para crear una orden.
            </div>
            <pre class="bg-black w-full">
              <code>
    {
      "order": {
        "service": "programmed",
        "vehicle": "moto",
        "points": [
          {
            "lat": -12.093302,
            "lng": -76.982942,
            "address": "Jr 2 Nro 359",
            "instructions": "Dpto 102 San Borja -
            Alt. Cuadra 1 Av. Velasco Astete",
            "contact": {
              "name": "Gisella Vancarcel",
              "phone": "991690316",
            }
          },
          {
            "lat": -12.093302,
            "lng": -76.982942,
            "address": "Jr 2 Nro 359 Dpto 102 San Borja",
            "instructions": "Alt. Cuadra 1 Av.
              Velasco Astete",
            "contact": {
              "name": "Leopoldo Rondon",
              "phone": "988229976"
            }
          }
        ]
      }
    }
              </code>
            </pre>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 40 + 'px' }"
            >
              Respuesta de la API si los datos de la orden son erróneos
            </div>
            <pre class="bg-black json">
              <code>
              {
                "errors": [
                  {
                    location:"string",
                    msg:"string"
                    param: "string",
                    value:{}
                  }
                ]
              }
              </code>
            </pre>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 80 + 'px' }"
            >
              Estructura de respuesta de una orden específica
            </div>
            <pre class="bg-black">
              <code>
[
  {
    "id": "23556",
    "number": 251,
    "service": "programmed",
    "vehicle": "moto",
    "status": "completed",
    "amount": 1450,
    "packages": [],
    "partner": {
      "user": {
        "name": {
          "first": "Soichi Staging",
          "last": "Tamashiro"
        }
      },
      "phone": "989963559"
    },
    "points": [
      {
        "address": "Óvalo de Miraflores,
          Miraflores, Peru",
        "lat": -12.1192613,
        "lng": -77.0292353,
        "contact": {
          "name": "Cristian Sanchez",
          "phone": "971449248"
        },
        "instructions": "",
        "done": "2022-07-27T20:56:55.015Z",
        "statePoint": "Recogido",
        "subStatePoint": "Subestado default",
        "chargePointImage": "https://s3.amazonaws.com/
          nirexcargos-userfiles-mobilehub
          -1913682982/cargos/IMAGE_20220727_155689.jpg",
        "chargeReceivedBy": "Cliente final",
        "descriptionPoint": "asdasdsadasd",
        "price": 500,
        "waitTime": 0
      },
      {
        "address": "Cruz del Sur, Avenida Javier
          Prado Este, San Isidro, Peru",
        "lat": -12.0918764,
        "lng": -77.027705,
        "contact": {
          "name": "Cristian Martinez",
          "phone": "948512651"
        },
        "instructions": "",
        "done": "2022-07-27T20:57:19.300Z",
        "statePoint": "No entregado",
        "subStatePoint": "Subestado default",
        "chargePointImage": "https://s3.amazonaws.com
          /nirexcargos-userfiles-mobilehub
          -1913682982/cargos/IMAGE_20220727_155788.jpg",
        "chargeReceivedBy": "cliente no quiere recibir",
        "descriptionPoint": "dfdfsdffs",
        "price": 950,
        "waitTime": 0
      }
    ],
    "customer": "60d618937681d84630729864",
    "createdAt": "2022-07-27T19:23:54.841Z",
    "updatedAt": "2022-08-05T14:31:42.876Z",
    "trackignUrl": "",
    "chargeOrder": "https://s3.amazonaws.com
      /nirexcargos-userfiles-mobilehub-
      1913682982/cargos/IMAGE_20220727_155788.jpg"
  }
]
              </code>
            </pre>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 40 + 'px' }"
            >
              Estructura de respuesta si una orden requerida no existe
            </div>
            <pre class="bg-black json">
              <code>
  {
    "msg":
      "El número de orden no existe
      en nuestra plataforma"
  }
              </code>
            </pre>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 40 + 'px' }"
            >
              Estructura de respuesta al cancelar una orden
            </div>
            <pre class="bg-black json">
              <code>
        {
          "msg": "Pedido cancelado exitosamente"
        }
              </code>
            </pre>
            <div
              class="border-2 w-full px-10 text-lg py-2"
              :style="{ marginTop: 40 + 'px' }"
            >
              Estructura de respuesta si la orden ya fue cancelada
            </div>
            <pre class="bg-black json">
              <code>
          {
            "codeError": 2001,
            "msg":
              "La orden {orderId} ya
              fue cancelada o no es un número
              de orden válido"
          }
              </code>
            </pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      padding: "",
      validateJson: [
        {
          atributo: "lat",
          type: "Number",
          description: "latitud de la direccion",
          prove: "cliente",
          request: "si",
        },
        {
          atributo: "long",
          type: "Number",
          description: "longitud de la direccion",
          prove: "cliente",
          request: "si",
        },
      ],
      orderJson: [
        {
          atributo: "service",
          type: "String",
          description: "Tipo de servicio",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "vehicle",
          type: "String",
          description: "Tipo de vehiculo 'moto' o 'auto'",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "points",
          type: "Array",
          description: "Puntos de una orden",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "contact",
          type: "Object",
          description: "Datos del contacto",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "name",
          type: "String, { contact }",
          description: "Nombre y apellidos del contacto",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "phone",
          type: "Number, { contact }",
          description: "Número de celular del contacto",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "mail",
          type: "string, { contact }",
          description: "Correo del contacto",
          prove: "cliente",
          request: "No",
        },
        {
          atributo: "lat",
          type: "Number",
          description: "latitud del punto",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "lng",
          type: "Number",
          description: "longitud del punto",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "address",
          type: "String",
          description: "Direccion exacta del punto",
          prove: "cliente",
          request: "Sí",
        },
        {
          atributo: "instructions",
          type: "String",
          description: "Instrucciones para llegar a una direccion",
          prove: "cliente",
          request: "Sí",
        },
      ],
      getOrderJSON: [
        {
          atributo: "id",
          type: "String",
          description: "ID de la órden",
          values: "any Number as a String",
          prove: "Nirex",
        },
        {
          atributo: "number",
          type: "Number",
          values: "any Number",
          description:
            "Número de órden creada por el cliente (dueño de la API key)",
          prove: "Nirex",
        },
        {
          atributo: "service",
          type: "String",
          values: "[programmed, sameday]",
          description: "Servicio correspondiente a la órden",
          prove: "Nirex",
        },
        {
          atributo: "vehicle",
          type: "String",
          values: "[moto, auto]",
          description: "Vehiculo usado para completar la órden",
          prove: "Nirex",
        },
        {
          atributo: "status",
          values:
            "['completed', 'arrived', 'cancelled', 'pending', 'confirmed', 'sending']",
          type: "String",
          description: "Estado actual de la órden",
          prove: "Nirex",
        },
        {
          atributo: "amount",
          values: "any Number",
          type: "Number",
          description: "Tarifa total de la órden",
          prove: "Nirex",
        },
        {
          atributo: "partner",
          values:
            "{ partner: { user: { name: {first: String, last: String}}, phone: String} }",
          type: "Object",
          description: "Datos del driver encargado de la órden",
          prove: "Nirex",
        },
        {
          atributo: "points",
          values: "{ points }, ver ejemplo de creación de órden",
          type: "Object",
          description: "Datos del driver encargado de la órden",
          prove: "Nirex",
        },
        {
          atributo: "customer",
          values: "any Number as a String",
          type: "String",
          description: "ID del cliente (dueño de la API key)",
          prove: "Nirex",
        },
        {
          atributo: "createdAt",
          values: "2022-07-27T19:23:54.841Z",
          type: "String",
          description:
            "Fecha y hora de creación de la órden (en formato ISOString)",
          prove: "Nirex",
        },
        {
          atributo: "updatedAt",
          values: "2022-07-27T19:23:54.841Z",
          type: "String",
          description:
            "Fecha y hora de entrega de la órden (en formato ISOString)",
          prove: "Nirex",
        },
        {
          atributo: "trackingUrl",
          values:
            "https://customer-staging.nirex.pe/tracking?order=23431-62b6396476b91811eb05d044",
          type: "String",
          description:
            "Link para seguimiento de la orden (se activa desde el recojo de la órden)",
          prove: "Nirex",
        },
        {
          atributo: "chargeOrder",
          values:
            "https://s3.amazonaws.com/nirexcargos-userfiles-mobilehub-1913682982/cargos/IMAGE_20220727_155788.jpg",
          type: "String",
          description: "Url de la foto del último punto entregado",
          prove: "Nirex",
        },
      ],
    };
  },
  mounted() {
    this._handleResize();
  },
  methods: {
    _handleResize() {
      let div = document.getElementById("api-order");
      let coords = div.getBoundingClientRect();
      this.padding = coords.top;
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  box-shadow: -1px 10px 17px -2px rgba(255, 0, 0, 0.11);
}
.container__div {
  max-width: 1360px;
  margin: 0 auto;
  @media only screen and (max-width: 1361px) {
    padding: 0 4%;
  }
}

.code__container {
  width: 100%;
}

a,
a:link,
a:visited {
  text-decoration: none;
  color: #0A50E6;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}

tbody tr {
  background-color: #73c9ff;
}

tbody tr:nth-child(even) {
  background-color: #85a7f6;
  color: white;
}

thead {
  background-color: #85a7f6;
}
</style>
